// This file serves as a single import point for environment configuration
// It will be replaced during the build process with the appropriate environment file
// based on the build command (e.g., npm run build:prod will use environment.prod.ts)

// Get environment from REACT_APP_ENV or default to 'local'
const env = process.env.REACT_APP_ENV || 'local';

// Log the environment being used to help with debugging
console.log(`Building with environment: ${env}`);

// Dynamically select the appropriate environment configuration
let selectedEnvironment;
try {
    switch (env) {
        case 'prod':
            selectedEnvironment = require('./environment.prod');
            break;
        case 'prod-in':
            selectedEnvironment = require('./environment.in.prod');
            break;
        case 'staging':
            selectedEnvironment = require('./environment.staging');
            break;
        case 'dev':
            selectedEnvironment = require('./environment.dev');
            break;
        case 'cloud-dev':
            selectedEnvironment = require('./environment.cloud-dev');
            break;
        case 'local':
            selectedEnvironment = require('./environment.local');
            break;
        case 'prod-india':
            selectedEnvironment = require('./environment.prod-india');
            break;
        default:
            selectedEnvironment = require('./environment.prod');
            break;
    }

    // Verify that the environment was loaded correctly
    if (!selectedEnvironment || !selectedEnvironment.environment) {
        throw new Error(`Failed to load environment: ${env}`);
    }

    console.log(`Successfully loaded environment: ${selectedEnvironment.environment.environmentName}`);
} catch (error) {
    console.error(`Error loading environment ${env}:`, error);
    console.warn('Falling back to dev environment');
    selectedEnvironment = require('./environment.dev');
}

// Export the selected environment
export const environment = selectedEnvironment.environment;

// TypeScript interface for environment configuration to ensure type safety
export interface Environment {
    production: boolean;
    environmentName: string;
    apiUrl: string;
    debugMode: boolean;
    enableConsoleLog: boolean;
    featureFlags?: {
        enableAnalytics: boolean;
        enableExperimentalFeatures: boolean;
    };
    services?: Record<string, any>;
}